import React, { useState, useEffect, useCallback } from 'react'
import PageHeader from '../PageHeader'
import { searchService } from '../../services/searchService'
import { useParams } from 'react-router-dom'
import { Box, Paper, Typography } from '@mui/material'
import { FullScreen as FullScreenComponent, useFullScreenHandle } from 'react-full-screen'
import Alert from '@mui/material/Alert'

import Toolbar from './Toolbar'
import SortInterface from './SortInterface'
import ScoresList from './ScoresList'

import './scores.css'
import DateInterface from './DateInterface'

const Scores = () => {
  const { groupId } = useParams()
  const REFRESH_INTERVAL_SECONDS = 30
  const today = new Date()

  const [sortBy, updateSortBy] = useState('ordered')
  const [allScores, updateAllScores] = useState([])
  const [viewingDate, setViewingDate] = useState(today)

  const [lastUpdate, updateLastUpdate] = useState(today)
  const [currentTime, setCurrentTime] = useState(today)

  const [loading, setLoading] = useState(true)
  const [error, setError] = useState('')

  const handle = useFullScreenHandle()

  const fetchScoreData = useCallback(async (signal) => {
    try {
      setLoading(true)
      const response = await searchService.getHydrationScores(groupId, sortBy, signal, viewingDate)
      updateScores(response.hydrationScores)
    } catch (err) {
      console.log('something went wrong')
      console.log(JSON.stringify(err, null, 2))
      setError(JSON.stringify(err, null, 2))
    } finally {
      setLoading(false)
    }
  })

  useEffect(() => {
    const abortController = new AbortController()
    fetchScoreData(abortController.signal)
    const tickerId = setInterval(() => { setCurrentTime(new Date()) }, 15000)

    let intervalId
    if (handle.active) {
      intervalId = setInterval(() => { fetchScoreData(abortController.signal) }, REFRESH_INTERVAL_SECONDS * 1000)
    } else {
      clearInterval(intervalId)
    }
    return () => {
      abortController.abort()
      clearInterval(intervalId)
      clearInterval(tickerId)
    }
  }, [sortBy, handle, viewingDate])

  const updateScores = (data) => {
    updateAllScores(data)
    updateLastUpdate(new Date())
  }

  const handleUpdate = (event) => {
    updateSortBy(event.target.value)
  }

  const updateInfo = () => {
    const abortController = new AbortController()
    fetchScoreData(abortController.signal)
  }

  return (
    <FullScreenComponent handle={handle} className='fullscreen-container'>
      <Box sx={{
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        backgroundColor: handle.active ? 'white' : '',
        padding: handle.active ? 3 : 0
      }}
      >

        {error &&
          <Alert severity='error'>{error}</Alert>}

        {!handle.active ? (<PageHeader title='Hydration Scores' />) : (<Typography variant='h2'>Hydration Scores</Typography>)}

        <DateInterface
          today={today}
          viewingDate={viewingDate}
          setViewingDate={setViewingDate}
        />

        <Paper sx={{
          display: 'flex',
          flexDirection: 'column',
          flexGrow: handle.active ? 1 : 0,
          justifyContent: 'space-between',
          marginTop: '30px',
          backgroundColor: handle.active ? '' : 'white'
        }}
        >
          <Box>

            <SortInterface
              sortBy={sortBy}
              handleSort={handleUpdate}
              isFullscreen={handle.active}
            />

            <ScoresList
              isFullscreen={handle.active}
              isLoading={loading}
              allScores={allScores}
            />
          </Box>

          <Toolbar
            lastUpdated={lastUpdate}
            currentTime={currentTime}
            updateInfoFn={updateInfo}
            isFullscreen={handle.active}
            exitFn={() => { handle.exit() }}
            enterFn={() => { handle.enter() }}
          />
        </Paper>
      </Box>
    </FullScreenComponent>
  )
}

export default Scores
